// iOS Safari ignores unrecognized extensions in accept (WebKit #279606).
// FIT has no registered UTType on iOS — include MIME fallbacks so .fit stays selectable.
const IOS_FILE_MIME_FALLBACKS = [
    'application/gpx+xml',
    'application/xml',
    'text/xml',
    'application/octet-stream',
    'application/zip',
    'application/x-zip-compressed',
];

export function fileAccept(...extensions) {
    return [...extensions, ...IOS_FILE_MIME_FALLBACKS].join(',');
}

export const MERGE_FILE_ACCEPT = fileAccept('.gpx', '.fit', '.zip');
export const FIT_FILE_ACCEPT = fileAccept('.fit');
export const CONVERT_FILE_ACCEPT = fileAccept('.gpx', '.fit', '.kml');
export const ZIP_FILE_ACCEPT = fileAccept('.zip');

export const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};

export const getErrorMessage = (error) => {
    // Kratos default error structure: { code, reason, message, metadata }
    // Or other backend/gateway returns: { message } or string
    return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.msg ||
        error?.message ||
        'Unknown error'
    );
};

